<script>

import Navbar from '@/components/Navbar'
import posts from '@/helpers/posts'
import isOnline from '@/helpers/online'
import isWrittenIn from '@/helpers/lang'

export default {
  name: 'blog',
  components: { Navbar },
  computed: {
    locale(){
      return this.$i18n.locale === 'de' ? 'de' : 'en';
    },
    posts(){
      return posts.filter(post => isOnline(post.slug, this.locale) && isWrittenIn(post.slug, this.locale));
    }
  },
  methods: {
    formattedDate(yyyyMm){
      const date = new Date(`${yyyyMm}-01T00:00:00`);
      const locale = this.locale === 'de' ? 'de-DE' : 'en-US';
      return new Intl.DateTimeFormat(locale, { year: 'numeric', month: 'long' }).format(date);
    },
    title(post){
      return post.title[this.locale] || post.title.en;
    }
  }
}
</script>

<template>
  <div>
    <navbar :lightTheme="true" :blogpost="true" />

    <v-container class="blog-index py-12">
      <h1 class="primary--text mb-8">{{ $t('links.blog') }}</h1>

      <router-link v-for="post in posts"
                   :key="post.slug"
                   :to="'/' + post.slug"
                   class="blog-index__item d-flex align-center">
        <div class="blog-index__icon dark-gradient d-flex align-center justify-center flex-shrink-0">
          <v-icon color="white" size="26">{{ post.icon }}</v-icon>
        </div>
        <div class="blog-index__text">
          <div class="blog-index__date">{{ formattedDate(post.date) }}</div>
          <div class="blog-index__title primary--text">{{ title(post) }}</div>
        </div>
      </router-link>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>

.blog-index {
  max-width: 820px;
}

.dark-gradient {
  background-color: #050a19!important;
  background: linear-gradient(125deg, rgba(5,10,25,1) 45%, rgb(3, 16, 53) 100%)!important;
}

.blog-index__item {
  display: flex;
  gap: 1.25rem;
  padding: 1rem 0.5rem;
  text-decoration: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  transition: background-color 0.15s ease-in-out;

  &:hover {
    background-color: rgba(0, 0, 0, 0.03);
  }
}

.blog-index__icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}

.blog-index__date {
  font-size: 0.85rem;
  opacity: 0.6;
  margin-bottom: 0.15rem;
}

.blog-index__title {
  font-size: 1.05rem;
  line-height: 1.4rem;
}

</style>
